/**
 * 领课相关控制器
 *
 * 领课流程（doReceive）：
 * 1. 判断是否登录，未登录则调用 login 进行登录
 * 2. 已登录则调用 openSelectStudent 打开选择学生弹窗
 * 3. 选择学生后或只有一个学生时，调用 confirmSelectStudent
 * 4. confirmSelectStudent 内，调用 recordStudentActivation 记录 Leads 激活（此接口无论成功与否，不影响后续流程）
 * 5. getStudentInfo 判断是否已有数学正价课和体验课单，如果有则跳转失败（只面向新用户）
 * 6. 如果没有则调用直接下单购课接口，根据结果显示反馈页
 */

import { Toast } from 'vant'
import sasdk from './sasdkinit'
import gateway from '@/_gateway.config'
import cookie from 'js-cookie'
import { getStudentInfo, getStudentList } from '@/api/account'
import { createOrder, createDamiOrder } from '@/api/order'
import '@/utils/gt'
import { isPhone } from '@/utils/vilidate'

// import GradeManage from '../model/GradeManage.js'

export default {
    data () {
        return {
            /** 领课相关数据 */
            receive: {
                /** 年级信息 */
                gradeInfo: {
                    selectedGradeIndex: 0,
                    gradeList: []
                },
                /** 学生信息 */
                studentInfo: {
                    displayPopup: false,
                    studentList: []
                },
                /** 领课结果 **/
                result: {
                    succeedType: 0,
                    failedType: 0,
                    studentName: ''
                }
            }
        }
    },
    methods: {
        async doReceive () {
            sasdk.receiveFreeCourse()
            if (!this.user.auth.logged) {
                if (this.user.view.inputmobile.trim()) {
                    if (!isPhone(this.user.view.inputmobile, 'CN')) {
                        Toast('请输入正确的手机号码')
                        return
                    }
                } else {
                    Toast('请输入您的手机号')
                    return
                }
                if (!this.user.view.inputcode.trim()) {
                    Toast('请输入短信验证码')
                    return
                }
                let loginResult = await this.login()
                if (loginResult) this.openSelectStudent()
            } else {
                this.openSelectStudent()
            }
        },

        async openSelectStudent () {
            Toast.loading()

            var response

            try {
                response = await getStudentList({ parentId: this.getParentID() })
            } catch (e) {
                Toast('获取孩子列表失败，请重试')
                return
            }

            Toast.clear()
            let data = response.data
            this.receive.studentInfo.studentList = data.map(student => {
                return {
                    id: student.id,
                    avatar: student.avatarUrl,
                    name: student.name
                }
            })

            if (this.receive.studentInfo.studentList.length > 1) {
                this.receive.studentInfo.displayPopup = true
            } else {
                this.confirmSelectStudent(this.receive.studentInfo.studentList[0])
            }
        },

        async confirmSelectStudent (student) {
            console.log(student)
            sasdk.registerPage({
                student_id: student.id
            })
            cookie.set('mbstudentid', student.id, {
                domain: gateway.domain
            })
            sasdk.studentReceiveFreeCourse()
            Toast.loading()
            this.receive.studentInfo.displayPopup = false
            this.receive.result.studentName = student.name
            try {
                await this.recordStudentActivation(student.id)
            } catch (e) {}

            var grade = this.receive.gradeInfo.gradeList[this.receive.gradeInfo.selectedGradeIndex]

            if (grade.grade < 5) {
                var responseStudentInfo
                try {
                    responseStudentInfo = await getStudentInfo({
                        studentId: student.id
                    })
                } catch (e) {
                    if (this.receive.studentInfo.studentList.length > 1) {
                        Toast('网络错误，请重试')
                        this.receive.studentInfo.displayPopup = true
                    } else {
                        this.receive.result.failedType = 1
                    }
                    return
                }
                console.log(responseStudentInfo)
                if (responseStudentInfo.data.hadMajorOrder || responseStudentInfo.data.hadTrialOrder) {
                    this.receive.result.succeedType = 2
                    Toast.clear()
                    return
                }
            }

            var response
            try {
                if (grade.grade > 5) {
                    // 小高
                    response = await createDamiOrder({
                        channelId: this.channelId,
                        skuId: grade.skuId,
                        spuId: grade.spuId,
                        studentId: student.id
                    })
                } else {
                    response = await createOrder({
                        secondChannel: 'VK_MATH_PARENT_QRCODE',
                        orderChannelId: this.channelId,
                        stageId: grade.courseStageId,
                        studentId: student.id
                    })
                }
            } catch (e) {
                if (this.receive.studentInfo.studentList.length > 1) {
                    Toast('网络错误，请重试')
                    this.receive.studentInfo.displayPopup = true
                } else {
                    this.receive.result.failedType = 1
                }
                return
            }

            console.log(response)

            if (response.code === 200) {
                // 成功领课
                this.receive.result.succeedType = 1
            } else if (response.code === 1000019) {
                // 已领过课
                this.receive.result.succeedType = 2
            } else {
                // 失败
                this.receive.result.failedType = 1
            }
            Toast.clear()
        }
    }
}
